type ToastType = 'success' | 'error';

const createToastContainer = () => {
  const container = document.createElement('div');
  container.style.cssText = `
    position: fixed;
    top: 1rem;
    right: 1rem;
    z-index: 9999;
  `;
  document.body.appendChild(container);
  return container;
};

const createToast = (message: string, type: ToastType) => {
  const toast = document.createElement('div');
  toast.style.cssText = `
    padding: 1rem;
    margin-bottom: 0.5rem;
    border-radius: 0.375rem;
    background-color: ${type === 'success' ? '#C6F6D5' : '#FED7D7'};
    color: ${type === 'success' ? '#22543D' : '#822727'};
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    opacity: 0;
    transform: translateY(-1rem);
  `;
  toast.textContent = message;
  return toast;
};

let container: HTMLDivElement | null = null;

export const toast = {
  success: (message: string) => {
    if (!container) container = createToastContainer();
    const toast = createToast(message, 'success');
    container.appendChild(toast);
    requestAnimationFrame(() => {
      toast.style.opacity = '1';
      toast.style.transform = 'translateY(0)';
    });
    setTimeout(() => {
      toast.style.opacity = '0';
      toast.style.transform = 'translateY(-1rem)';
      setTimeout(() => {
        container?.removeChild(toast);
        if (container?.childNodes.length === 0) {
          document.body.removeChild(container);
          container = null;
        }
      }, 300);
    }, 3000);
  },
  error: (message: string) => {
    if (!container) container = createToastContainer();
    const toast = createToast(message, 'error');
    container.appendChild(toast);
    requestAnimationFrame(() => {
      toast.style.opacity = '1';
      toast.style.transform = 'translateY(0)';
    });
    setTimeout(() => {
      toast.style.opacity = '0';
      toast.style.transform = 'translateY(-1rem)';
      setTimeout(() => {
        container?.removeChild(toast);
        if (container?.childNodes.length === 0) {
          document.body.removeChild(container);
          container = null;
        }
      }, 300);
    }, 3000);
  }
}; 